var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"myImage",attrs:{"src":_vm._f("IMAGE_FILTER")(_vm.url),"alt":_vm.alt},on:{"error":_vm.loadDefaultImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }